// schema/nodes/grid.ts
import { html } from "lit";
import { toDOMByTemplate } from "../../client/util.js";
import { HTMLBaseContainerGrid } from "../../db/HTMLBaseContainerGrid.js";
var GRID_CELL_SCHEMA = () => ({
  attrs: {
    class: { default: "" }
  },
  content: "block+",
  group: "gridCell",
  selectable: true,
  isolating: true,
  draggable: true,
  parseDOM: [
    {
      tag: "node-grid-cell",
      getAttrs(dom) {
        return {
          class: dom.getAttribute("class")
        };
      }
    }
  ],
  toDOM: (node) => {
    return ["node-grid-cell", { class: node.attrs.class }, 0];
  }
});
var GRID_SCHEMA = () => ({
  draggable: true,
  content: "gridCell+",
  group: "block",
  isolating: true,
  inline: false,
  defining: true,
  atom: true,
  attrs: {
    data: { default: JSON.stringify(new HTMLBaseContainerGrid({}).toObject()) }
  },
  parseDOM: [
    {
      tag: "node-grid",
      getAttrs(dom) {
        return {
          data: dom.getAttribute("data")
        };
      }
    }
  ],
  toDOM: (node) => {
    return toDOMByTemplate(html` <node-grid data=${node.attrs.data}></node-grid> `);
  }
});
var GRID_CELL_KEY = "grid-cell";
var GRID_KEY = "grid";
var GRID = {
  [GRID_CELL_KEY]: GRID_CELL_SCHEMA,
  [GRID_KEY]: GRID_SCHEMA
};
export {
  GRID,
  GRID_CELL_KEY,
  GRID_CELL_SCHEMA,
  GRID_KEY,
  GRID_SCHEMA
};
